import { doFetch } from "./ConnectionManager";

export const getApp = async (appName, setLoading) => {
  setLoading(true);

  let app;

  await doFetch("SSO", "getAllAplicaciones", null)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      app = data.DATA.find((element) => element.nombre === appName);
    })
    .catch((error) => {
      console.error(
        "Error al obtener datos:",
        JSON.stringify(error, null, 2)
      );
    })
    .finally(() => {
      setLoading(false);
    });
  return app;
}

export const getAppPermisions = async (selectedApp, setLoading) => {
    let permisosList = [];
    if (selectedApp && selectedApp.IDAplicacion) {
      let idApp = selectedApp.IDAplicacion;
      setLoading(true);

      let requestOptions = {
        method: "GET",
      };

      let method = "getMyAppPermisions?IDAplicacion=" + idApp;

      await doFetch("SSO", method, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          permisosList = data.DATA;
        })
        .catch((error) => {
          console.error(
            "Error al obtener datos:",
            JSON.stringify(error, null, 2)
          );
        })
        .finally(() => {
            setLoading(false);
        });
    }
    return permisosList;
  }